var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hover"},[_c('div',{staticClass:"friend-select"},[_c('ItemRefList',{attrs:{"ignore":_vm.ignore,"items":_vm.list},on:{"input":function($event){return _vm.$emit('input', $event)}}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }